import styled from 'styled-components'
import { Grid } from '@material-ui/core'
import { px2rem, colors } from './index'


export const MidsizedGridContainerWithWhiteBackground = styled(Grid)`
    background: ${colors.white};
    padding: 2rem;
    max-width: 80%;
    margin: 5rem auto;
}
`

export const LargeFontParagraph = styled.p`
  font-size: ${px2rem(18)}rem;
`

export const VerticallyCenteredFlexboxWrapper = styled(Grid)`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: center;
    align-items: flex-start;
    && img {
      align-self: center;
    }
`

export const ErrorMessageIconJSS = {
  display: 'inherit',
  width: '40%',
  maxWidth: 'initial',
  maxHeight: 'initial'
}
